var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRemoteapply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 190,
    height: 44,
    viewBox: "0 0 190 44",
    role: "img",
    "aria-label": "RemoteApply",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 31,
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 28,
    fontWeight: 700,
    letterSpacing: -0.6
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#16202E"
  }, "Remote"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#2563EB"
  }, "Apply"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRemoteapply);
export default __webpack_public_path__ + "static/media/logo-remoteapply.457f35bc10bbe020784e397983880a37.svg";
export { ForwardRef as ReactComponent };